import { render } from "./PanelsPage.vue?vue&type=template&id=6e9fbd7c&ts=true"
import script from "./PanelsPage.vue?vue&type=script&lang=ts"
export * from "./PanelsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__